import adminRequest from 'utils/adminRequest'
import ErrorMessage from 'utils/ErrorMessage'

// ── Action Types ─────────────────────────────────────────────

export const SET_STUDENTS = 'metaDashboard/SET_STUDENTS'
export const SET_STUDENTS_LOADING = 'metaDashboard/SET_STUDENTS_LOADING'
export const SET_STUDENT_SUMMARY = 'metaDashboard/SET_STUDENT_SUMMARY'
export const SET_STUDENT_PROFILE = 'metaDashboard/SET_STUDENT_PROFILE'
export const SET_STUDENT_PROFILE_LOADING = 'metaDashboard/SET_STUDENT_PROFILE_LOADING'
export const SET_STUDENT_ASSESSMENTS = 'metaDashboard/SET_STUDENT_ASSESSMENTS'
export const SET_STUDENT_ASSESSMENTS_LOADING = 'metaDashboard/SET_STUDENT_ASSESSMENTS_LOADING'

export const SET_CORPORATE_SUMMARY = 'metaDashboard/SET_CORPORATE_SUMMARY'
export const SET_CORPORATE_GLOBAL_SUMMARY = 'metaDashboard/SET_CORPORATE_GLOBAL_SUMMARY'
export const SET_CORPORATE_DEPARTMENTS = 'metaDashboard/SET_CORPORATE_DEPARTMENTS'
export const SET_CORPORATE_DEPARTMENTS_TABLE = 'metaDashboard/SET_CORPORATE_DEPARTMENTS_TABLE'
export const SET_CORPORATE_DEPARTMENTS_TABLE_LOADING = 'metaDashboard/SET_CORPORATE_DEPARTMENTS_TABLE_LOADING'
export const SET_CORPORATE_SHORTLIST = 'metaDashboard/SET_CORPORATE_SHORTLIST'
export const SET_CORPORATE_SHORTLIST_TABLE = 'metaDashboard/SET_CORPORATE_SHORTLIST_TABLE'
export const SET_CORPORATE_SHORTLIST_TABLE_LOADING = 'metaDashboard/SET_CORPORATE_SHORTLIST_TABLE_LOADING'
export const SET_CORPORATE_LOADING = 'metaDashboard/SET_CORPORATE_LOADING'
export const SET_CORPORATE_CAMPUS_QUALITY = 'metaDashboard/SET_CORPORATE_CAMPUS_QUALITY'
export const SET_CORPORATE_CAMPUS_QUALITY_TABLE = 'metaDashboard/SET_CORPORATE_CAMPUS_QUALITY_TABLE'
export const SET_CORPORATE_CAMPUS_QUALITY_TABLE_LOADING = 'metaDashboard/SET_CORPORATE_CAMPUS_QUALITY_TABLE_LOADING'

export const SET_CORPORATE_PLACEMENT_SUMMARY = 'metaDashboard/SET_CORPORATE_PLACEMENT_SUMMARY'
export const SET_CORPORATE_COMPANIES = 'metaDashboard/SET_CORPORATE_COMPANIES'
export const SET_CORPORATE_COMPANIES_LOADING = 'metaDashboard/SET_CORPORATE_COMPANIES_LOADING'

export const SET_INSTITUTE_PLACEMENT = 'metaDashboard/SET_INSTITUTE_PLACEMENT'
export const SET_INSTITUTE_PLACEMENT_LOADING = 'metaDashboard/SET_INSTITUTE_PLACEMENT_LOADING'

export const SET_INSTITUTES = 'metaDashboard/SET_INSTITUTES'
export const SET_INSTITUTES_LOADING = 'metaDashboard/SET_INSTITUTES_LOADING'
export const SET_INSTITUTE_SUMMARY = 'metaDashboard/SET_INSTITUTE_SUMMARY'
export const SET_INSTITUTE_SUMMARY_LOADING = 'metaDashboard/SET_INSTITUTE_SUMMARY_LOADING'

export const SET_FILTER_DEPARTMENTS = 'metaDashboard/SET_FILTER_DEPARTMENTS'
export const SET_FILTER_STATES = 'metaDashboard/SET_FILTER_STATES'
export const SET_FILTER_DEGREES = 'metaDashboard/SET_FILTER_DEGREES'
export const SET_FILTER_COLLEGES = 'metaDashboard/SET_FILTER_COLLEGES'
export const SET_FILTER_SKILLS = 'metaDashboard/SET_FILTER_SKILLS'
export const SET_FILTER_CITIES = 'metaDashboard/SET_FILTER_CITIES'

// ── Action Creators ──────────────────────────────────────────

export const setStudents = data => ({ type: SET_STUDENTS, data })
export const setStudentsLoading = loading => ({ type: SET_STUDENTS_LOADING, data: loading })
export const setStudentSummary = data => ({ type: SET_STUDENT_SUMMARY, data })
export const setStudentProfile = data => ({ type: SET_STUDENT_PROFILE, data })
export const setStudentProfileLoading = loading => ({ type: SET_STUDENT_PROFILE_LOADING, data: loading })
export const setStudentAssessments = data => ({ type: SET_STUDENT_ASSESSMENTS, data })
export const setStudentAssessmentsLoading = loading => ({ type: SET_STUDENT_ASSESSMENTS_LOADING, data: loading })

export const setCorporateSummary = data => ({ type: SET_CORPORATE_SUMMARY, data })
export const setCorporateGlobalSummary = data => ({ type: SET_CORPORATE_GLOBAL_SUMMARY, data })
export const setCorporateDepartments = data => ({ type: SET_CORPORATE_DEPARTMENTS, data })
export const setCorporateDepartmentsTable = data => ({ type: SET_CORPORATE_DEPARTMENTS_TABLE, data })
export const setCorporateDepartmentsTableLoading = loading => ({ type: SET_CORPORATE_DEPARTMENTS_TABLE_LOADING, data: loading })
export const setCorporateShortlist = data => ({ type: SET_CORPORATE_SHORTLIST, data })
export const setCorporateShortlistTable = data => ({ type: SET_CORPORATE_SHORTLIST_TABLE, data })
export const setCorporateShortlistTableLoading = loading => ({ type: SET_CORPORATE_SHORTLIST_TABLE_LOADING, data: loading })
export const setCorporateLoading = loading => ({ type: SET_CORPORATE_LOADING, data: loading })
export const setCorporateCampusQuality = data => ({ type: SET_CORPORATE_CAMPUS_QUALITY, data })
export const setCorporateCampusQualityTable = data => ({ type: SET_CORPORATE_CAMPUS_QUALITY_TABLE, data })
export const setCorporateCampusQualityTableLoading = loading => ({ type: SET_CORPORATE_CAMPUS_QUALITY_TABLE_LOADING, data: loading })

export const setCorporatePlacementSummary = data => ({ type: SET_CORPORATE_PLACEMENT_SUMMARY, data })
export const setCorporateCompanies = data => ({ type: SET_CORPORATE_COMPANIES, data })
export const setCorporateCompaniesLoading = loading => ({ type: SET_CORPORATE_COMPANIES_LOADING, data: loading })

export const setInstitutePlacement = data => ({ type: SET_INSTITUTE_PLACEMENT, data })
export const setInstitutePlacementLoading = loading => ({ type: SET_INSTITUTE_PLACEMENT_LOADING, data: loading })

export const setInstitutes = data => ({ type: SET_INSTITUTES, data })
export const setInstitutesLoading = loading => ({ type: SET_INSTITUTES_LOADING, data: loading })
export const setInstituteSummary = data => ({ type: SET_INSTITUTE_SUMMARY, data })
export const setInstituteSummaryLoading = loading => ({ type: SET_INSTITUTE_SUMMARY_LOADING, data: loading })

export const setFilterDepartments = data => ({ type: SET_FILTER_DEPARTMENTS, data })
export const setFilterStates = data => ({ type: SET_FILTER_STATES, data })
export const setFilterDegrees = data => ({ type: SET_FILTER_DEGREES, data })
export const setFilterColleges = data => ({ type: SET_FILTER_COLLEGES, data })
export const setFilterSkills = data => ({ type: SET_FILTER_SKILLS, data })
export const setFilterCities = data => ({ type: SET_FILTER_CITIES, data })

// Some meta-dashboard list endpoints now return a pagination envelope
// `{ data: [...], count, page, limit, totalPages, ... }` instead of a
// raw array. The institute/corporate tabs still treat their slice as a
// plain array (`institutes.reduce(...)`, `companies.map(...)`), so we
// unwrap the envelope here to keep those components working without a
// per-component refactor. Pass-through if the payload is already an
// array (older backends / non-paginated callers).
const unwrapList = (payload) => {
  if (Array.isArray(payload)) return payload
  if (payload && Array.isArray(payload.data)) return payload.data
  return []
}

// Normalise a list endpoint response into the pagination envelope the
// server-side tables consume: { data, total, page, limit }. Accepts either a
// raw array (older / non-paginated responses) or a backend envelope
// ({ data, total/count, page, limit }). `params` provides page/limit
// fallbacks so the table's pagination stays in sync when the backend omits
// them.
const toEnvelope = (payload, params = {}) => {
  const isArray = Array.isArray(payload)
  return {
    data:  isArray ? payload : (payload?.data || []),
    total: isArray ? payload.length : (payload?.total ?? payload?.count ?? 0),
    page:  (isArray ? null : payload?.page)  || params.page  || 1,
    limit: (isArray ? null : payload?.limit) || params.limit || 10,
  }
}

// ── Thunks ───────────────────────────────────────────────────

// Filter-bearing endpoints use POST so multi-select arrays (dept,
// degree, state, college, gender, …) don't bloat the URL past Fastify
// / proxy length limits. The backend handler merges req.query + req.body
// so the same handler serves both methods. Pure lookups
// (/students/:id, /filters/*, etc.) stay GET.

export const fetchStudents = (filters = {}) => async dispatch => {
  try {
    dispatch(setStudentsLoading(true))
    const response = await adminRequest.post('/meta-dashboard/students', filters)
    dispatch(setStudents(response?.data?.data || { data: [], page: 1, limit: 50 }))
    dispatch(setStudentsLoading(false))
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch students')
    dispatch(setStudentsLoading(false))
  }
}

export const fetchStudentSummary = (filters = {}) => async dispatch => {
  try {
    const response = await adminRequest.post('/meta-dashboard/students-summary', filters)
    dispatch(setStudentSummary(response?.data?.data || {}))
  } catch {
    // non-critical
  }
}

export const fetchStudentAssessments = id => async dispatch => {
  try {
    dispatch(setStudentAssessmentsLoading(true))
    const response = await adminRequest.get(`/meta-dashboard/students/${id}/assessments`)
    dispatch(setStudentAssessments(response?.data?.data || []))
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch assessment scores')
    dispatch(setStudentAssessmentsLoading(false))
  }
}

export const fetchStudentProfile = id => async dispatch => {
  try {
    dispatch(setStudentProfileLoading(true))
    const response = await adminRequest.get(`/meta-dashboard/students/${id}`)
    dispatch(setStudentProfile(response?.data?.data || null))
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch student profile')
    dispatch(setStudentProfileLoading(false))
  }
}

export const fetchCorporateData = (filters = {}) => async dispatch => {
  try {
    dispatch(setCorporateLoading(true))
    // /corporate/summary is fetched twice on this tab:
    //  - `filters` (with company) drives the Gender Distribution chart
    //    inside Analytics Overview, which the user did want
    //    company-scoped.
    //  - filters without `company` drive the top KPI strip
    //    (Total Candidates / Avg Marks / Zero Arrears / High Performers)
    //    so picking a single company doesn't blank that strip out — the
    //    strip is meant to give platform-wide context regardless of the
    //    company-scope filter.
    // allSettled so a single slow/failing endpoint (e.g. shortlist timeout)
    // doesn't prevent the other successful responses from reaching the store.
    const [summaryRes, summaryGlobalRes, deptsRes, shortlistRes, campusQualityRes] =
      await Promise.allSettled([
        adminRequest.post('/meta-dashboard/corporate/summary', filters),
        adminRequest.post('/meta-dashboard/corporate/summary', {}),
        adminRequest.post('/meta-dashboard/corporate/departments', filters),
        adminRequest.post('/meta-dashboard/corporate/shortlist', filters),
        adminRequest.post('/meta-dashboard/corporate/campus-quality', filters),
      ])
    const val = r => r.status === 'fulfilled' ? r.value : null
    dispatch(setCorporateSummary(val(summaryRes)?.data?.data || {}))
    dispatch(setCorporateGlobalSummary(val(summaryGlobalRes)?.data?.data || {}))
    dispatch(setCorporateDepartments(unwrapList(val(deptsRes)?.data?.data)))
    dispatch(setCorporateShortlist(unwrapList(val(shortlistRes)?.data?.data)))
    dispatch(setCorporateCampusQuality(unwrapList(val(campusQualityRes)?.data?.data)))
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch corporate data')
    dispatch(setCorporateLoading(false))
  }
}

// Department Breakdown table — fully server-side (pagination + search +
// sorting). Kept separate from the department fetch inside
// fetchCorporateData, which only feeds the top-N "Department Distribution"
// chart. Every page / page-size / search / sort change in the table fires
// this thunk with the corresponding params and the backend returns a
// pagination envelope { data, total, page, limit }.
export const fetchCorporateDepartmentsTable = (params = {}) => async dispatch => {
  try {
    dispatch(setCorporateDepartmentsTableLoading(true))
    const response = await adminRequest.post('/meta-dashboard/corporate/departments', params)
    dispatch(setCorporateDepartmentsTable(toEnvelope(response?.data?.data, params)))
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch departments')
    dispatch(setCorporateDepartmentsTableLoading(false))
  }
}

// Top Candidates Shortlist table — fully server-side. Separate from the
// shortlist fetch inside fetchCorporateData, which feeds the Marks
// Distribution chart. Refetched on every page / size / search / sort /
// cohort-filter change.
export const fetchCorporateShortlistTable = (params = {}) => async dispatch => {
  try {
    dispatch(setCorporateShortlistTableLoading(true))
    const response = await adminRequest.post('/meta-dashboard/corporate/shortlist', params)
    dispatch(setCorporateShortlistTable(toEnvelope(response?.data?.data, params)))
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch shortlist')
    dispatch(setCorporateShortlistTableLoading(false))
  }
}

// Campus Quality Ranking table — fully server-side. Refetched on every
// page / size / search / sort / cohort-filter change.
export const fetchCorporateCampusQualityTable = (params = {}) => async dispatch => {
  try {
    dispatch(setCorporateCampusQualityTableLoading(true))
    const response = await adminRequest.post('/meta-dashboard/corporate/campus-quality', params)
    dispatch(setCorporateCampusQualityTable(toEnvelope(response?.data?.data, params)))
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch campus quality')
    dispatch(setCorporateCampusQualityTableLoading(false))
  }
}

export const fetchCorporatePlacementSummary = () => async dispatch => {
  try {
    const response = await adminRequest.get('/meta-dashboard/corporate/placement-summary')
    dispatch(setCorporatePlacementSummary(response?.data?.data || {}))
  } catch {
    // non-critical
  }
}

// Companies table — fully server-side. Stores a pagination envelope
// { data, total, page, limit }; the table renders envelope.data and drives
// pagination off envelope.total. The Company filter dropdown reads the
// separate `allCompanies` snapshot, so narrowing this slice via search
// doesn't shrink the dropdown.
export const fetchCorporateCompanies = (params = {}) => async dispatch => {
  try {
    dispatch(setCorporateCompaniesLoading(true))
    const response = await adminRequest.post('/meta-dashboard/corporate/companies', params)
    dispatch(setCorporateCompanies(toEnvelope(response?.data?.data, params)))
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch companies')
    dispatch(setCorporateCompaniesLoading(false))
  }
}

export const fetchInstitutePlacement = (id, filters = {}) => async dispatch => {
  try {
    dispatch(setInstitutePlacementLoading(true))
    const response = await adminRequest.post(`/meta-dashboard/institutes/${id}/placement`, filters)
    const payload = response?.data?.data || null
    if (payload) {
      // Backend wraps `companies` in a pagination envelope — the
      // InstituteTab table renders it as an array, so unwrap here.
      payload.companies = unwrapList(payload.companies)
    }
    dispatch(setInstitutePlacement(payload))
  } catch {
    dispatch(setInstitutePlacementLoading(false))
  }
}

export const fetchInstitutes = (filters = {}) => async dispatch => {
  try {
    dispatch(setInstitutesLoading(true))
    const response = await adminRequest.post('/meta-dashboard/institutes', filters)
    dispatch(setInstitutes(unwrapList(response?.data?.data)))
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch institutes')
    dispatch(setInstitutesLoading(false))
  }
}

export const fetchInstituteSummary = (id, filters = {}) => async dispatch => {
  try {
    dispatch(setInstituteSummaryLoading(true))
    const response = await adminRequest.post(`/meta-dashboard/institutes/${id}/summary`, filters)
    dispatch(setInstituteSummary(response?.data?.data || null))
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch institute summary')
    dispatch(setInstituteSummaryLoading(false))
  }
}

// Helper: append ?search=… (and any other query params) to a base path.
// Used by the server-side-search dropdowns below. The backend treats
// empty / absent search as "no filter" and returns the default
// alphabetical page.
const _withQuery = (path, params = {}) => {
  const entries = Object.entries(params).filter(([, v]) => v !== undefined && v !== null && String(v).length > 0)
  if (!entries.length) return path
  const qs = entries.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
  return `${path}?${qs}`
}

// Every Student-360 dropdown does server-side search now. These thunks
// are fired by debounced onSearch handlers in StudentTab — the Select
// uses filterOption={false} on the client so it just renders whatever
// the API returned for the current keystroke. Empty input returns the
// default alphabetical page (LIMIT 500) so the dropdown isn't blank on
// first focus.

// Skills — DB has 10k+ rows, API capped at 500/200 per response.
export const fetchFilterSkills = (search) => async dispatch => {
  try {
    const res = await adminRequest.get(_withQuery('/meta-dashboard/filters/skills', { search }))
    dispatch(setFilterSkills(res?.data?.data || []))
  } catch { /* silent — keep previous list */ }
}

// Departments — scoped to the optional currently-selected college so
// the search results stay relevant to that college's actual departments.
export const fetchFilterDepartments = ({ search, college } = {}) => async dispatch => {
  try {
    const res = await adminRequest.get(_withQuery('/meta-dashboard/filters/departments', { search, college }))
    dispatch(setFilterDepartments(res?.data?.data || []))
  } catch { /* silent */ }
}

// Degrees — same college-scoping as Departments.
export const fetchFilterDegrees = ({ search, college } = {}) => async dispatch => {
  try {
    const res = await adminRequest.get(_withQuery('/meta-dashboard/filters/degrees', { search, college }))
    dispatch(setFilterDegrees(res?.data?.data || []))
  } catch { /* silent */ }
}

// States.
export const fetchFilterStates = (search) => async dispatch => {
  try {
    const res = await adminRequest.get(_withQuery('/meta-dashboard/filters/states', { search }))
    dispatch(setFilterStates(res?.data?.data || []))
  } catch { /* silent */ }
}

// Cities — distinct student cities (union of correspondence + permanent city),
// server-side searched. Backs the multi-select City filter on Student 360.
export const fetchFilterCities = (search) => async dispatch => {
  try {
    const res = await adminRequest.get(_withQuery('/meta-dashboard/filters/cities', { search }))
    dispatch(setFilterCities(res?.data?.data || []))
  } catch { /* silent */ }
}

// Colleges.
export const fetchFilterColleges = (search) => async dispatch => {
  try {
    const res = await adminRequest.get(_withQuery('/meta-dashboard/filters/colleges', { search }))
    dispatch(setFilterColleges(res?.data?.data || []))
  } catch { /* silent */ }
}

export const fetchFilterOptions = ({ college } = {}) => async dispatch => {
  try {
    // Departments + Degrees are now scoped to the optional college so the
    // dropdowns on Student 360 only show the options that exist at the
    // selected college. States + Colleges stay global.
    const deptUrl    = college ? `/meta-dashboard/filters/departments?college=${encodeURIComponent(college)}` : '/meta-dashboard/filters/departments'
    const degreeUrl  = college ? `/meta-dashboard/filters/degrees?college=${encodeURIComponent(college)}`     : '/meta-dashboard/filters/degrees'
    const [deptsRes, statesRes, degreesRes, collegesRes, skillsRes, citiesRes] = await Promise.all([
      adminRequest.get(deptUrl),
      adminRequest.get('/meta-dashboard/filters/states'),
      adminRequest.get(degreeUrl),
      adminRequest.get('/meta-dashboard/filters/colleges'),
      adminRequest.get('/meta-dashboard/filters/skills'),
      adminRequest.get('/meta-dashboard/filters/cities'),
    ])
    dispatch(setFilterDepartments(deptsRes?.data?.data || []))
    dispatch(setFilterStates(statesRes?.data?.data || []))
    dispatch(setFilterDegrees(degreesRes?.data?.data || []))
    dispatch(setFilterColleges(collegesRes?.data?.data || []))
    dispatch(setFilterSkills(skillsRes?.data?.data || []))
    dispatch(setFilterCities(citiesRes?.data?.data || []))
  } catch (error) {
    // non-critical, silent fail
  }
}

// Google-Sheets-style cascading filter options for Candidate 360. Single
// API call replaces the 6 separate fetches above. Returns options for
// every category, computed from the same SQL as the candidate list, with
// all currently-active filters applied EXCEPT the one being computed.
//
// `skipCategory` — name of the category the user is actively browsing
// (so the server-side search results in that category aren't blown
// away by the cascading response). Pass 'college' while the user has
// the College tab open in the modal, etc.
//
// (Skills aren't included server-side — keep using fetchFilterSkills.)
export const fetchStudentFilterOptions = (filters = {}, skipCategory = null) => async dispatch => {
  try {
    const res = await adminRequest.post('/meta-dashboard/students/filter-options', filters)
    const d = res?.data?.data || {}

    // Defensive shape guards. Catches cases where the backend ever
    // accidentally returns `colleges` data in another slot — a misshaped
    // response would otherwise poison filterDepartments etc. and surface
    // as "the Department dropdown is showing college names".
    const isCollegeArray = (arr) =>
      Array.isArray(arr) && arr.every(v => v && typeof v === 'object' && 'id' in v && 'name' in v)
    const isStringArray = (arr) =>
      Array.isArray(arr) && arr.every(v => typeof v === 'string')

    if (skipCategory !== 'college' && isCollegeArray(d.colleges))   dispatch(setFilterColleges(d.colleges))
    if (skipCategory !== 'degree'  && isStringArray(d.degrees))     dispatch(setFilterDegrees(d.degrees))
    if (skipCategory !== 'dept'    && isStringArray(d.departments)) dispatch(setFilterDepartments(d.departments))
    if (skipCategory !== 'state'   && isStringArray(d.states))      dispatch(setFilterStates(d.states))
    if (skipCategory !== 'city'    && isStringArray(d.cities))      dispatch(setFilterCities(d.cities))
    if (skipCategory !== 'skill'   && isStringArray(d.skills))      dispatch(setFilterSkills(d.skills))
  } catch { /* non-critical; previous lists remain */ }
}
